import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { FlatList } from "react-native";
import { clearDB, fetchLogs } from '@reduxLocal/persistState';
import { View, Text, Title } from "@constants/Themed";
import moment from "moment";
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import { getModernCardStyle, getModernTextColor } from '@stylesheet';

const LogViewer = forwardRef((props, ref) => {
  const [logs, setLogs] = useState([]);
  const globalDate = useSelector((state: DefaultRootState) => state.UI.dateFormat);
  const theme = themeSelector();

  useImperativeHandle(ref, () => ({
    refresh: () => fetchLogs().then(setLogs),
    clear: () => { clearDB(); setLogs([]); },
    getLogCount: () => logs.length
  }));

  useEffect(() => {
    fetchLogs().then(setLogs);
  }, []);

  const renderItem = ({ item }) => {
    const cardStyle = getModernCardStyle ? getModernCardStyle(theme, 'medium') : { backgroundColor: theme ? '#fff' : '#222', borderRadius: 12, padding: 14 };
    const titleColor = getModernTextColor ? getModernTextColor(theme, 'primary') : (theme ? '#222' : '#fff');
    const secondaryColor = getModernTextColor ? getModernTextColor(theme, 'muted') : (theme ? '#666' : '#aaa');
    return (
      <View style={[cardStyle, { marginVertical: 6, flexDirection: 'row', alignItems: 'flex-start', gap: 10 }]}>
        <View style={{ flex: 4 }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 2 }}>
            {item.type !== 'API_REQUEST' ? (
              <Title style={{ flex: 1, color: titleColor, fontWeight: 600, fontSize: 16 }}>{item.action}</Title>
            ) : (
              <Title style={{ flex: 1, color: titleColor, fontWeight: 600, fontSize: 16 }}>{item.type}</Title>
            )}
            <Text style={{ flex: 1, textAlign: 'right', color: secondaryColor, fontSize: 11, opacity: 0.7 }}>
              {moment(item.timestamp).format(globalDate)}{"\n"}{moment(item.timestamp).format('HH:mm:ss')}
            </Text>
          </View>
          <Text style={{ fontWeight: 'bold', color: titleColor, marginBottom: 2, fontSize: 13 }}>
            {item.method || JSON.stringify(item.payload)}
          </Text>
          {item.url && (
            <Text style={{ color: secondaryColor, fontSize: 12, marginTop: 1 }}>{item.url}</Text>
          )}
        </View>
      </View>
    );
  };

  return (
    <FlatList
      data={logs}
      keyExtractor={(_, idx) => String(idx)}
      renderItem={renderItem}
      ListEmptyComponent={<Text style={{ textAlign: 'center', marginTop: 20, color: '#888' }}>Logs will appear here when actions are performed</Text>}
    />
  );
});
export default LogViewer;